import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

const options = {
  load: false,
  installComponents: true,
};

Vue.use(VueGoogleMaps, options);
